(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"]) return;
  try {
    

$(function(){
	$('.faq-panel h3').on('click', function (){
		$(this).toggleClass('appear');
		$(this).siblings('.rte').slideToggle();
		return false;
	})
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["login"]) return;
  try {
    

$('.create-account').on('click', function(){
  $('.content-block--register__create').css({
  'opacity': '0',
  'visibility': 'hidden',
  'height': '0'
  });
  $('.content-block--register__form').css({
  'opacity': '1',
  'visibility': 'visible',
  'height': 'auto'
  });
  return false;
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    

function process_slick_event(){
$('.js-main-slider').each(function(){
  $(this).slick({
    accessibility: true,
    infinite: true,
    dots: true,
    appendArrows: $(this).next(),
    appendDots: $(this).next()
  });
});
}

$(function(){
  process_slick_event();
});

$(document)
.on( 'shopify:section:load', process_slick_event )


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-info"] && !window.DesignMode) return;
  try {
    

$(function(){
  $('.info-block-list__link').on('click', function(){
    var show_link = $(this).data('show');
    $('.info-block-list__link').removeClass('active');
    $(this).addClass('active');
    $('.' + show_link).siblings().removeClass('info-block__inner--show');
    $('.' + show_link).addClass('info-block__inner--show');
  return false;
  });
})


  } catch(e) { console.error(e); }
})();
})();
